const white = {
  primary: '#FFF',
  hover: '#F8FAFC',
  active: '#F2F5F7',
};

const accent = {
  primary: '#80B344',
};

const black = {
  primary: '#333333',
};

const muted = {
  primary: '#9DA5B0',
};

const gray = {
  hover: '#D9DDE3',
  active: '#CBCFD4',
  primary: '#E5EAF0',
};

const graydark = {
  hover: '#9EA7B0',
  active: '#858C94',
  primary: '#7D848D',
};

const greenlight = {
  primary: '#EEF4E8',
};

const greendark = {
  shadow8: '#51818114',
  shadow14: '#51818124',
  shadow20: '#00484233',
  shadow26: '#51818142',
};

export const blue = {
  hover: '#0186BF',
  active: '#0186BF',
  primary: '#0C7BAA',
  secondary: {
    hover: '#0186BF',
    active: '#0186BF',
    primary: '#0C7BAA',
  },
};

const bluedark = {
  primary: '#1F2C4A',
};

const accentlight = {
  primary: '#BFE388',
};

const silver = {
  primary: '#A6A6A6',
};

const charcoal = {
  primary: '#3D3D3D',
};

const navy = {
  primary: '#1C2336',
  secondary: '#46506B',
};

const red = {
  secondary: { hover: '#FADDDD', active: '#F1C9C8', primary: '#FFEFEF' },
  primary: {
    hover: '#E55653',
    active: '#D14A47',
    primary: '#FD6460',
  },
};

export const colors = {
  red,
  blue,
  gray,
  navy,
  white,
  muted,
  black,
  accent,
  silver,
  charcoal,
  graydark,
  bluedark,
  greendark,
  greenlight,
  accentlight,
};
